(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('FinalizadosListController.js', FinalizadosListController);
    

    FinalizadosListController.$inject = [
  
    ];

     function FinalizadosListController(){
        
    }

})();